import Vue from 'vue';

// initial state
const state = {
  categories: {
    wildcard: [],
    adoption: [],
  },
  products: {
    wildcard: [],
    adoption: [],
  },
  filteredProducts: [],
  selectedCategories: [],
  selectedProductType: 'wildcard', // 'wildcard' or 'adoption'
  isSeeingAll: false,
};

// getters
const getters = {
  categories: (state) => state.categories,
  ecommerceProducts: (state) => state.products,
  filteredProducts: (state) => state.filteredProducts,
  selectedCategories: (state) => state.selectedCategories,
  selectedProductType: (state) => state.selectedProductType,
  isSeeingAll: (state) => state.isSeeingAll,
};

// mutations
const mutations = {
  categoriesLoaded: (state, categories) => {
    state.categories = categories;
  },
  productsLoaded: (state, products) => {
    state.products = products;
  },
  selectedProductTypeUpdated: (state, value) => {
    state.selectedProductType = value;
  },
  selectedCategoriesUpdated: (state, value) => {
    state.selectedCategories = value;
  },
  filteredProductsUpdated: (state, filteredProducts) => {
    state.filteredProducts = filteredProducts;
  },
  isSeeingAllUpdated: (state, value) => {
    state.isSeeingAll = value;
  },
};

// actions
const actions = {
  getEcommerceProducts({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${wwfconfigs.WEB_API}/product/ecommerce`)
        .then((response) => {
          const products = {
            wildcard: [],
            adoption: [],
          };
          const categories = {
            wildcard: [],
            adoption: [],
          };

          // Load and categorise ecommerce products
          // id: product.id,
          // name: product.meta.projectTitle,
          // image: product.meta.image,
          // url: product.meta.productUrl,
          // description: product.meta.description,
          // categories: productCategories,
          // type: product.producttype,

          for (const product of response.body) {
            if (product.type === 'wildcard') {
              products.wildcard.push(product);
              for (const category of product.categories) {
                if (!categories.wildcard.some((c) => c.id === category.id)) {
                  categories.wildcard.push(category);
                }
              }
            }

            if (product.type === 'adoption') {
              products.adoption.push(product);
              for (const category of product.categories) {
                if (!categories.adoption.some((c) => c.id === category.id)) {
                  categories.adoption.push(category);
                }
              }
            }
          }

          categories.wildcard.sort((a, b) => a.index - b.index);
          categories.adoption.sort((a, b) => a.index - b.index);

          commit('productsLoaded', products);
          commit('categoriesLoaded', categories);
          dispatch('filterProducts');
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAllEcommerceProducts() {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${wwfconfigs.WEB_API}/product/ecommerce`)
        .then((response) => {
          resolve(response.body);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  filterProducts({ commit, state }) {
    if (state.selectedCategories.length == 0) {
      commit('filteredProductsUpdated', state.products[state.selectedProductType]);
    } else {
      const filteredProducts = [];
      for (const product of state.products[state.selectedProductType]) {
        for (const category of state.selectedCategories) {
          // If the product has one of the selected category and
          // the filtered product list doesn't contain the product
          // add it to the filtered product list
          if (
            product.categories.some((c) => c.id === category.id) &&
            !filteredProducts.some((p) => p.id === product.id)
          ) {
            filteredProducts.push(product);
          }
        }
      }
      commit('filteredProductsUpdated', filteredProducts);
    }
  },
  updateSelectedCategories({ commit, dispatch }, value) {
    commit('selectedCategoriesUpdated', value);
    dispatch('filterProducts');
  },
  updateSelectedProductType({ commit, dispatch }, value) {
    commit('selectedProductTypeUpdated', value);
    dispatch('filterProducts');
  },
  updateIsSeeingAll({ commit }, value) {
    commit('isSeeingAllUpdated', value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/ecommerce.js